import { useState } from "react";
import { createContext } from "react";
import clienteAxios from "../config/clienteAxios";
import getBanners from "../services/getBanners";
import putBanners from "../services/putBanners";
import getBloqueInfo from "../services/getBloqueInfo";
import putBloqueInfo from "../services/putBloqueInfo";
import toast from "react-hot-toast";
import { changeVisibilityArticle } from "../services/articlesServices";
import { filterCategories } from "../helpers/functions";

const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const [sliders, setSliders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bloques, setBloques] = useState([]);
  const [mensaje, setMensaje] = useState(null);
  const [bloqueInfoEdit, setBloqueInfoEdit] = useState(null);
  const [bannerEdit, setBannerEdit] = useState(null);
  const [flag, setFlag] = useState(false);


  const getCategories = async () => {
    try {
      const { data } = await clienteAxios.get('/category');
      setCategories(filterCategories(data?.allCategories));
    } catch (error) {
      console.log(error);
    }
  };

  const createCategory = async (category) => {
    try {
      const response = clienteAxios.post('/category');
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const addCategory = (category) => {
    const nuevoArray = categories.some((cat) => cat.title === category.title);
    if (!nuevoArray) {
      createCategory(category).then((resp) => setMensaje("Creado"));
    }
    const newCategory = [...categories, category];
    setCategories(newCategory);
    setMensaje(null);
  };

  const handleVisibilitySlider = async (id, visibility) => {
    try {
      visibility.state = !visibility.state;
      const response = await changeVisibilityArticle(id, visibility);
      return response;
    } catch (error) {
      toast.error('Error al actualizar articulo');
    }
  };

  const handleVisibilityBanners = (module, page) => {
    const updateSection = true;

    setBanners(
      banners.map((item) => {
        if (item._id === module) {
          if (item.section.find((value) => value === page)) {
            const index = item.section.indexOf(page);
            item.section.splice(index, 1);
          } else {
            item.section.push(page);
          }
        }
        return item;
      })
    );
    const bannerToEdit = banners.find((b) => b._id === module);
    bannerToEdit.state = !bannerToEdit.state;
    putBanners({ ...bannerToEdit, updateSection });
  };
  
  const getBannersInfo = async () => {
    try {
      const { data } = await getBanners();
      setBanners(data?.allBanner);
    } catch (error) {
      toast.error('Error al obtener la informacion de los banners');
    }
  };
  const editBanner = (values) => {
    const bannersEdit = banners.map((b) => (b._id === values._id ? { ...values } : b));
    putBanners({ ...values, updated_date: new Date() }).then(({ data }) =>
      toast.success(data.message)
    );
    setBanners(bannersEdit);
  };

  const handleVisibilityBloque = (module, page) => {
    const updateSection = true;
    setBloques(
      bloques.map((item) => {
        if (item._id === module) {
          if (item.visible.find((value) => value === page)) {
            const index = item.visible.indexOf(page);
            item.visible.splice(index, 1);
          } else {
            item.visible.push(page);
          }
        }
        return item;
      })
    );

    const bloqueToEdit = bloques.find((b) => b._id === module);
    bloqueToEdit.state = !bloqueToEdit.state;
    putBloqueInfo({ ...bloqueToEdit, updateSection });
  };

  return (
    <HomeContext.Provider
      value={{
        getBannersInfo,
        sliders,
        banners,
        mensaje,
        handleVisibilitySlider,
        editBanner,
        setFlag,
        flag,
        handleVisibilityBanners,
        addCategory,
        categories,
        setCategories,
        bloques,
        handleVisibilityBloque,
        setBloques,
        setBanners,
        bloqueInfoEdit,
        setBloqueInfoEdit,
        setBannerEdit,
        bannerEdit,
        getCategories,
        getBanners,
        getBloqueInfo,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export { HomeProvider };

export default HomeContext;
